// @flow

import * as React from 'react';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import Logging from '@ta/common.logging';
import type { MemberProfile } from '@ta/social.member-types';
import { SuggestedFolloweesLoadingSkeleton } from '@ta/social.skeletons';

import SuggestedFolloweesQuery from './SuggestedFollowees.gql';

type ExternalProps = {|
  /** children is a function that accepts a suggestedFollowees render props */
  children: ({ suggestedFollowees: MemberProfile[] }) => React.Node,
  /** number of followees to fetch */
  limit?: number,
  /** location id to scope relevant suggestions */
  locationId?: number,
|};

type Props = {|
  ...ExternalProps,
  /** prop supplied from redux store via connect */
  userId: string,
  /** locale to filter relevant suggestions */
  locale: string,
|};

const FolloweeDataProvider = (props: Props) => (
  <Query
    errorPolicy="all"
    query={SuggestedFolloweesQuery}
    variables={{
      userId: props.userId,
      /* $FlowFixGraphql (WP-1357) */
      locationId: props.locationId,
      /* $FlowFixGraphql (WP-1357) */
      limit: props.limit,
      locale: props.locale,
    }}
  >
    {({ data, error, loading }) => {
      if (error) {
        Logging.error(error);
      }
      if (data && data.suggestedFollowees) {
        /* $FlowFixGraphql (WP-1357) */
        return props.children(data);
      }
      if (loading) {
        return <SuggestedFolloweesLoadingSkeleton />;
      }
      return null;
    }}
  </Query>
);

FolloweeDataProvider.defaultProps = {
  limit: 5,
  locationId: undefined,
};

export default connect<Props, ExternalProps, _, _, _, _>((state, ownProps: ExternalProps) => ({
  userId: state.auth.loggedInUserId,
  locationId: ownProps.locationId || state.page.geoId || null,
  locale: state.i18n.locale,
}))(FolloweeDataProvider);
